export default {
  title: 'Not Found Page',
  header: 'Not Found'
}
